export default "__VITE_ASSET__5fd87dd4__"